import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiClient from '../../../utils/apiClient';
import { Button } from '../../../components/ui/button';
import { Card } from '../../../components/ui/card';
import { ArrowLeft } from 'lucide-react';

export default function Usage() {
  const { orgId } = useParams();
  const navigate = useNavigate();
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUsage();
  }, [orgId]);

  const fetchUsage = async () => {
    try {
      const response = await apiClient.get(`/billing/orgs/${orgId}/usage`);
      setUsage(response.data);
    } catch (error) {
      console.error('Failed to fetch usage:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8 space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" onClick={() => navigate(`/enterprise/orgs/${orgId}/billing`)}>
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
        <div>
          <h1 className="font-heading text-2xl font-bold text-gray-900">Usage</h1>
          <p className="text-gray-600 mt-1">Current billing period usage</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="p-6 rounded-lg">
          <p className="text-sm text-gray-600 mb-1">AI Messages</p>
          <p className="text-3xl font-bold text-gray-900">{usage?.aiMessages || 0}</p>
          <p className="text-xs text-gray-500 mt-1">This month</p>
        </Card>

        <Card className="p-6 rounded-lg">
          <p className="text-sm text-gray-600 mb-1">Storage Used</p>
          <p className="text-3xl font-bold text-gray-900">
            {((usage?.storageBytes || 0) / (1024 * 1024 * 1024)).toFixed(2)} GB
          </p>
          <p className="text-xs text-gray-500 mt-1">Total storage</p>
        </Card>

        <Card className="p-6 rounded-lg">
          <p className="text-sm text-gray-600 mb-1">Active Users</p>
          <p className="text-3xl font-bold text-gray-900">{usage?.activeUsers || 0}</p>
          <p className="text-xs text-gray-500 mt-1">This month</p>
        </Card>
      </div>
    </div>
  );
}
